import { FormikErrors } from 'formik';
import {
  PublishingDataDto,
  CreatePublishingDataDto,
  DownloadFileDto } from '@sr/dto';
import { validateSlug } from 'utils/slug-validation';
import { FormTools } from 'utils/form-tools';

export type PublishingDataFormData = {
  slug: string,
  shortDescription: string,
  fullDescription: string,
  benefits: string,
  specificConditions: string,
  smallImage: DownloadFileDto[],
  detailedImage: DownloadFileDto[]
  isPublished: boolean,
  isSubdomain: boolean
}

const toCreateDto = (formData:PublishingDataFormData): CreatePublishingDataDto => ({
  ...formData,
  isPublished: formData.isPublished,
  isSubdomain:formData.isSubdomain,
  smallImage: formData.smallImage.length > 0  ?formData.smallImage[0] : null,
  detailedImage: formData.detailedImage.length > 0 ? formData.detailedImage[0] : null
});

export const formTools: FormTools<PublishingDataDto, CreatePublishingDataDto, PublishingDataDto, PublishingDataFormData> = {
  fromDto: (dto: PublishingDataDto): PublishingDataFormData => ({
    slug: dto.slug,
    shortDescription: dto.shortDescription,
    fullDescription: dto.fullDescription,
    benefits: dto.benefits,
    smallImage: dto.smallImage ? [dto.smallImage]: [],
    detailedImage: dto.detailedImage ? [dto.detailedImage]: [],
    specificConditions: dto.specificConditions,
    isPublished: dto.isPublished,
    isSubdomain: dto.isSubdomain
  }),
  toCreateDto,
  toUpdateDto: (id, formData): PublishingDataDto=>({
    ...toCreateDto(formData),
    id
  }),
  validate: (values):FormikErrors<PublishingDataFormData>=>{
    let validationResult: FormikErrors<PublishingDataFormData> = {};
    const slugValidation = validateSlug(values.slug);
    slugValidation && (validationResult.slug = slugValidation);
    return validationResult;
  },
  emptyValues: (): PublishingDataFormData => ({
    slug: '',
    shortDescription: '',
    fullDescription: '',
    benefits: '',
    specificConditions: '',
    isPublished: false,
    isSubdomain: false,
    smallImage: [],
    detailedImage: []
  })
};
